export enum VehicleCampaignStatusEnum {
  UNKNOWN,
  CANCELED,
  ERROR,
  EXECUTED,
}
